<template>
  <div class="workorder-status-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="statusOptions"
      display-by="label"
      value-by="value"
      :multiple="true"
      v-model="model"
      search-placeholder="Search status..."
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';

interface StatusOption {
  label: string;
  value: number;
}

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Status' 
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const statusOptions = ref<StatusOption[]>([
  { label: 'Draft', value: 0 },
  { label: 'Pending', value: 1 },
  { label: 'Approved', value: 2 },
  { label: 'Complete', value: 3 },
  { label: 'Cancelled', value: 4 },
  { label: 'Finalized', value: 5 },
  { label: 'Assigned', value: -2 },
  { label: 'Deleted', value: -1 }
]);

const handleChange = (value: number[]) => {
  emit('change', value);
};
</script>
